/**
 * Human workflow node purposes — My Work panels and API task enrichment.
 */

/**
 * @typedef {{
 *   purpose: string,
 *   entityTypes: string[],
 *   taskTypes: string[],
 *   myWorkPanel: string,
 *   flags?: Record<string, string>,
 *   detect?: { nodeIdFallback?: string },
 * }} WorkflowHumanPurposeEntry
 */

/** @type {WorkflowHumanPurposeEntry[]} */
export const WORKFLOW_HUMAN_PURPOSE_REGISTRY = [
    {
        purpose: 'ticket-dispatch',
        entityTypes: ['Ticket', 'Incident'],
        taskTypes: ['REVIEW'],
        myWorkPanel: 'TicketDispatchAssignPanel',
        flags: { isTicketDispatchTask: 'true' },
        detect: { nodeIdFallback: 'rev-dispatch' },
    },
    {
        purpose: 'ticket-on-hold',
        entityTypes: ['Ticket', 'Incident'],
        taskTypes: ['REVIEW'],
        myWorkPanel: 'TicketOnHoldPanel',
        flags: { isTicketOnHoldTask: 'true' },
        detect: { nodeIdFallback: 'rev-on-hold' },
    },
    {
        purpose: 'ticket-resume',
        entityTypes: ['Ticket', 'Incident'],
        taskTypes: ['REVIEW'],
        myWorkPanel: 'TicketResumePanel',
        flags: { isTicketResumeTask: 'true' },
        detect: { nodeIdFallback: 'rev-resume' },
    },
];

export function getHumanPurposeEntry(purpose) {
    if (!purpose) return null;
    return WORKFLOW_HUMAN_PURPOSE_REGISTRY.find((e) => e.purpose === purpose) || null;
}

export function listHumanPurposeCodes() {
    return WORKFLOW_HUMAN_PURPOSE_REGISTRY.map((e) => e.purpose);
}

/**
 * @param {{ resourceType?: string, nodeId?: string, taskType?: string, workflowNodePurpose?: string|null }} ctx
 */
export function detectHumanPurposeFlags(ctx) {
    const flags = {};
    const resourceType = String(ctx.resourceType || '');
    const taskType = String(ctx.taskType || '');

    for (const entry of WORKFLOW_HUMAN_PURPOSE_REGISTRY) {
        if (!entry.entityTypes.includes(resourceType)) continue;
        if (entry.taskTypes.length && !entry.taskTypes.includes(taskType)) continue;

        const purposeMatch = ctx.workflowNodePurpose === entry.purpose;
        const nodeMatch = entry.detect?.nodeIdFallback && ctx.nodeId === entry.detect.nodeIdFallback;
        if (!purposeMatch && !nodeMatch) continue;

        for (const [flag, val] of Object.entries(entry.flags || {})) {
            flags[flag] = val === 'true';
        }
    }

    return flags;
}
